import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { FormField } from '../../models/form-builder/form-field.model';
import { GridFilter, FilterClause } from '../../models/grid/grid-filter.model';

export class GridPresetFiltersDialogModel {
    public columns: FormField[];
    constructor(columnDefs: FormField[]) {
        this.columns = columnDefs;
    }
}

@Component({
    selector: 'app-grid-preset-filters-dialog',
    templateUrl: './grid-preset-filters-dialog.component.html',
    styleUrls: ['./grid-preset-filters-dialog.component.scss'],
    standalone: false //VNEXT-1430: KLW - Adding the standalone property that was missed in the Angular 19 migration
})

export class GridPresetFiltersDialog implements OnInit {
    private filterClauses: FilterClause[];

    public filterFieldValue: string;
    public filterOperator: string;
    public filterColumn = new UntypedFormControl();
    public filterName: string;

    constructor(public dialogRef: MatDialogRef<GridPresetFiltersDialog>,
        @Inject(MAT_DIALOG_DATA) public data: GridPresetFiltersDialogModel) { }

    ngOnInit() {
        this.filterClauses = [];
    }

    public get Columns(): FormField[] {
        return this.data.columns;
    }

    public get FilterClauses() {
        return this.filterClauses;
    }

    public addFilterButtonClick(): void {
        if (!this.filterFieldValue) return;

        let filterOperatorDescription = 'equal to';
        if (this.filterOperator == 'neq') filterOperatorDescription = 'not equal to';
        if (this.filterOperator == 'contains') filterOperatorDescription = 'contains';

        let fc: FilterClause = {
            columnId: this.filterColumn.value,
            columnName: this.data.columns.find(c => c.id == this.filterColumn.value)?.name,
            columnDisplayName: this.data.columns.find(c => c.id == this.filterColumn.value)?.displayName,
            filterOperatorAbbreviation: this.filterOperator,
            filterOperatorDescription: filterOperatorDescription,
            filterMatchValue: this.filterFieldValue
        };

        this.filterClauses.push(fc);

        if (!this.filterName) {
            this.filterName = fc.columnDisplayName + ' ' + filterOperatorDescription + ' ' + this.filterFieldValue;
        }

        this.filterOperator = '';
        this.filterFieldValue = '';
    }

    public saveButtonClicked() {
        let filter: GridFilter = { filterName: this.filterName, filters: [] };
        for (let i: number = 0; i < this.filterClauses.length; i++) {
            let fc: FilterClause = {
                columnId: this.filterClauses[i].columnId,
                columnName: this.filterClauses[i].columnName,
                columnDisplayName: this.filterClauses[i].columnDisplayName,
                filterOperatorDescription: this.filterClauses[i].filterOperatorDescription,
                filterMatchValue: this.filterClauses[i].filterMatchValue,
                filterOperatorAbbreviation: this.filterClauses[i].filterOperatorAbbreviation
            }
            filter.filters.push(fc);
        }
        this.dialogRef.close(filter);
    }

    public deleteButtonClicked() {
        let filter: GridFilter = { filterName: '', filters: []};
        this.dialogRef.close(filter)
    }
}

//The supported operators are:

//"eq" (equal to)
//"neq" (not equal to)
//"isnull" (is equal to null)
//"isnotnull" (is not equal to null)
//"lt" (less than)
//"lte" (less than or equal to)
//"gt" (greater than)
//"gte" (greater than or equal to)

//The following operators are supported for string fields only:

//"startswith"
//"endswith"
//"contains"
//"doesnotcontain"
//"isempty"
//"isnotempty"

//https://www.telerik.com/kendo-angular-ui/components/data-query/api/filterdescriptor
